<template>
    <div
        :class="classCard"
        class="card-carousel-card"
        @click="$emit('select')"
    >
        <div class="image">
            <a href="#">
                <CmsImage
                    :data="data.image"
                    :is-eager="hasEagerImage"
                    fit="cover"
                />
            </a>
        </div>

        <div class="content">
            <h3 class="title">
                <a href="#">
                    {{ data.title }}
                </a>
            </h3>

            <div class="description">
                <a href="#">
                    {{ data.description }}
                </a>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { CardCarouselCardFragment } from '@/graphql/api'
import type { ButtonColors } from '@/components/ui/buttons'
import { getColorForBackground } from '@/components/ui/buttons'
import { cmsColorToButtonColor } from '@/components/cms'
import type { Colors } from '@/components/ui'

import CmsImage from '@/components/cms/CmsImage.vue'

const props = defineProps<{
    data: CardCarouselCardFragment
    isSelected: boolean
    hasEagerImage?: boolean
}>()

defineEmits<{
    select: []
}>()

const classCard = computed(() => ({
    selected: props.isSelected,
}))

const backgroundColor = computed((): ButtonColors => {
    return cmsColorToButtonColor(props.data.backgroundColor)
})

const color = computed((): Colors => {
    return getColorForBackground(backgroundColor.value)
})
</script>

<style lang="scss" scoped>
.card-carousel-card {
    position: relative;
    z-index: 2;
    background: v-bind(backgroundColor);
    color: v-bind(color);
    height: 450px;

    @media (hover: hover) {
        height: 330px;

        &:hover {
            height: 450px;
        }
    }

    .image {
        height: 260px;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .content {
        position: absolute;
        top: 260px;
        height: 70px;
        padding: 20px 30px;

        .title {
            font-size: 1.5rem;
            line-height: 1.875rem;
            height: 30px;
            margin: 0 0 20px;
            display: block;
            font-family: $parcel-font-stack;
            letter-spacing: 0.01em;
        }
    }

    @media (hover: hover) {
        .content {
            .description {
                overflow-y: hidden;
                height: 0;
            }
        }
    }

    @include hover() {
        .content {
            height: 190px;

            .description {
                height: 100px;
            }
        }
    }
}
</style>
